import {
    createSlice,
    createEntityAdapter,
} from '@reduxjs/toolkit';
import { inplayEventData } from '~SpectateStore/thunks/inplayEventData';
import { nonTradingEventUpdate } from '~SpectateStore/actions/nonTradingEventUpdate';
import { storeCleanup } from '~SpectateStore/actions/storeCleanupActions';
import {
    moreGamesUpdate,
} from '~SpectateStore/actions/moreGamesActions';
import {
    dataPointersUpdate,
} from '~SpectateStore/actions/dataPointersActions';

export const SLICE_NAME = 'scoreboards';

export const scoreboardsAdapter = createEntityAdapter();

const scoreboardsSlice = createSlice({
    name: SLICE_NAME,
    initialState: scoreboardsAdapter.getInitialState({
        scorecentreProviders: {},
    }),
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(
                storeCleanup,
                (state, { payload : { eventIds } }) => {
                    scoreboardsAdapter.removeMany(state, eventIds);
                },
            )
            .addCase(
                inplayEventData.fulfilled,
                (state, { payload : { scoreboard, scorecentre } }) => {
                    state.scorecentreProviders = scorecentre ?? {};

                    if (Object.keys(scoreboard).length > 0) {
                        return scoreboardsAdapter.addOne(state, scoreboard);
                    }

                    return state;
                },
            )
            .addCase(
                nonTradingEventUpdate,
                (state, { payload : { scoreboard } }) => {
                    if (scoreboard?.id) {
                        return scoreboardsAdapter.upsertOne(state, scoreboard);
                    }

                    return state;
                },
            )
            .addCase(
                moreGamesUpdate,
                (state, { payload : { scoreboards } }) => {
                    scoreboardsAdapter.addMany(state, scoreboards);
                },
            )
            .addCase(
                dataPointersUpdate,
                (state, { payload : { scoreboards = {} } }) => {
                    if (Object.keys(scoreboards).length > 0) {
                        return scoreboardsAdapter.upsertMany(state, scoreboards);
                    }

                    return state;
                },
            );
    },
});

export default scoreboardsSlice.reducer;
